import {
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_EXCLUDE_ARCHIVED_FIELD_NAME,
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_FIELD_NAME,
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_OWNERS_OPTION,
} from './RequestProfileTabEmailsAttachedRequestsRecipientsFilterModal.constants'

export function getInitialValues(t) {
  return {
    [ATTACHED_REQUESTS_MODE_FILTER_MODAL_EXCLUDE_ARCHIVED_FIELD_NAME]: false,
    [ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_FIELD_NAME]: {
      ...ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_OWNERS_OPTION,
      label: t(
        ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_OWNERS_OPTION.label
      ),
    },
  }
}
